import { render, staticRenderFns } from "./Yklist.vue?vue&type=template&id=3597be63&scoped=true"
import script from "./Yklist.vue?vue&type=script&lang=js"
export * from "./Yklist.vue?vue&type=script&lang=js"
import style0 from "./Yklist.vue?vue&type=style&index=0&id=3597be63&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3597be63",
  null
  
)

export default component.exports